var map = {
	"./0.jpg": 941,
	"./1.jpg": 942,
	"./10.jpg": 943,
	"./11.jpg": 944,
	"./12.jpg": 945,
	"./13.jpg": 946,
	"./14.jpg": 947,
	"./2.jpg": 948,
	"./3.jpg": 949,
	"./4.jpg": 950,
	"./5.jpg": 951,
	"./6.jpg": 952,
	"./7.jpg": 953,
	"./8.jpg": 954,
	"./9.jpg": 955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 940;